import styled from 'styled-components';

export const StyledModal = styled.div`
  background-color: #ffffff;
  display: flex;
  box-shadow: 0 8px 32px rgb(196 200 204 / 48%), 0 1px 4px rgb(0 36 77 / 8%);
  border-radius: 8px;
  box-sizing: border-box;
  padding: 0;
`;

export const ModalWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 532px;
`;

export const ContentWrapper = styled.div`
  width: 100%;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 16px;
  right: -56px;
  background-color: rgb(0, 36, 77);
  color: rgb(255, 255, 255);
  border: none;
  padding: 0;
  margin: 0;
  width: 56px;
  height: 56px;
  cursor: pointer;
  transition: background-color 80ms ease-in-out 0s;

  :hover {
    background-color: rgb(235, 0, 47);
  }
`;
